<template>
  <el-dialog :visible.sync="currentValue" title="新建标签" custom-class="tag-manage-dialog" width="539px" :append-to-body="true" top="auto">
    <div class="tag-manage-dialog-box">
      <div class="content">
        <el-form class="my-form" ref="form" label-position="top" :model="form" size="large">
          <el-form-item label="标签名称" prop="name">
            <el-input ref="input" v-model="form.name" placeholder="请输入标签名称" maxlength="20"></el-input>
          </el-form-item>
          <el-form-item label="成员" prop="uid">
            <el-popover placement="bottom" trigger="click" v-model="isFocus" class="participant-out">
              <div class="popover-content" slot="reference">
                <wf-button plain type="text" size="large" auto  v-if="selectMember && selectMember.length === 0"><i class="icon iconfont iconicon_enlarge"></i> 添加成员</wf-button>
                <div class="has-select-input" :class="{'has-select-input-active': isFocus}" v-else>
                  <div class="member-content">
                    <Myavatar v-for="item in selectMember" :key="item.key" width="28px" height="28px" :imgUrl="item.user_avatar" :userName="item.realname"></Myavatar>
                  </div>
                  <i class="icon iconfont iconicon_drop_down_arrow arrow" :class="{'rota90': !isFocus}"></i>
                </div>
              </div>
              <ParticipantList
                v-if="isFocus"
                v-model="selectMember"
                @confirm="handlerSelectValue"
                :taskMemberlist="taskMemberlist"
                @close="isFocus = false"
              ></ParticipantList>
            </el-popover>
          </el-form-item>
        </el-form>
        <div class="footer">
          <span class="text-btn-active" style="margin-right: 24px;" @click="currentValue = false">取消</span>
          <wf-button :disabled="disabled" @click="handlerClick">确定</wf-button>
        </div>
      </div>
    </div>
  </el-dialog>
</template>
<script>
import ParticipantList from '@/views/customKeyPage/components/participant/participantList'
import { mapActions, mapState } from 'vuex'
import api from '@/services/api/project/project'
import bus from '@/bus'
export default {
  props: ['value', 'project_id'],
  components: {
    ParticipantList,
  },
  data() {
    return {
      form: {
        name: '',
        uid: []
      },
      selectMember: [],
      isFocus: false,
      uidList: [],
      taskMemberlist: [],
    }
  },
  computed: {
    currentValue: {
      get: function () {
        if (this.value) {
          this.init()
        }
        return this.value || undefined;
      },
      set: function (newValue) {
        this.$emit('input', newValue || null)
      }
    },
    disabled() {
      return !this.form.name || (this.form.uid && this.form.uid.length === 0)
    },
     ...mapState('project/project', {
      projectMember: state => state.newMember
    }),
  },
  methods: {
    ...mapActions('task/task', ['getTaskMember']),
    async init() {
      this.taskMemberlist = JSON.parse(JSON.stringify(this.projectMember))
      this.$nextTick(() => {
        this.$refs.input.focus()
      })
    },
    close() {
      this.isFocus = false
    },
    handlerSelectValue(val) {
      this.selectMember = JSON.parse(JSON.stringify(val))
      this.form.uid = val.map(res => res.uid)
      this.close()
    },
    async handlerClick() {
      await api.projectTagSave({ project_id: this.project_id, label_name: this.form.name, members: this.form.uid })
      this.$message({
        message: '新建标签成功',
        type: 'success'
      })
      bus.$emit('getProjectMembers')
      this.$emit('success')
      this.currentValue = false
    },
  },
}
</script>
<style lang="scss">
.tag-manage-dialog--tag {
  .el-select-dropdown__list {
    padding-bottom: 0;
  }
  .add-tag {
    height: 48px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-top: 1px solid rgba(32, 32, 32, 0.08);
    font-size: 14px;
    i {
      margin-right: 9px;
      font-size: 14px;
    }
    position: sticky;
    bottom: 0;
    left: 0;
    right: 0;
    background-color: #fff;
    z-index: 1;
  }
  .tag-name {
    i {
      color: #FF3939;
      font-size: 14px;
      margin-left: 8px;
      line-height: 1;
      display: none;
    }
  }
  .el-select-dropdown__item {
    &:hover {
      .tag-name i{
        display: inline;
      }
    }
  }
}
.tag-manage-dialog {
  .popover-content {
    .has-select-input {
      height: 40px;
      border: 1px solid rgba(32, 32, 32, 0.16) !important;
      display: flex;
      align-items: center;
      border-radius: 4px;
      padding-left: 16px;
      cursor: pointer;
      &:hover {
        border: 1px solid rgba(32, 32, 40, 0.6) !important;
      }
      &.has-select-input-active {
        border: 1px solid #0D70E8 !important;
      }
    }
    .member-content {
      display: flex;
      align-items: center;
      width: 0;
      flex: 1;
      overflow: hidden;
    }
    i {
      color: #C0C4CC;
      padding: 0 8px;
      font-size: 14px;
      transform: rotate(270deg);
      transition: all .3s;
    }
  }
  .el-dialog__body {
    padding: 0;
  }
  .el-dialog__header {
    padding: 16px 24px;
    border-bottom: 1px solid rgba(32, 32, 32, 0.08);
  }
  .el-dialog__headerbtn {
    top: 16px;
  }
  .nothing {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: 48px;
    img {
      width: 100px;
    }
    span {
      font-size: 14px;
      color: rgba(32, 32, 32, 0.8);
      margin-top: 19px;
      margin-bottom: 26px;
    }
  }
  .tag-manage-dialog-box {
    width: 100%;
    height: 334px;
    display: flex;
    flex-direction: column;
  }
  .content {
    height: 100%;
    display: flex;
    flex-direction: column;
    .my-form {
      padding: 24px;
      height: 0;
      flex: 1;
    }
    .el-select {
      width: 100%;
    }
    .footer {
      height: 64px;
      display: flex;
      align-items: center;
      justify-content: flex-end;
      padding: 0 25px;
      border-top: 1px solid rgba(32, 32, 32, 0.08);
    }

  }
}
</style>
